import React from "react";
import { Controller, get, useFormContext } from "react-hook-form";
import ExpandableTextarea from "./ExpandableTextarea";

export default function RHFTextarea({ name, className, ...props }) {
    const { control, formState: { errors } } = useFormContext();
    const error = get(errors, name);

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) =>  (
                <ExpandableTextarea
                    {...field}
                    {...props}
                    className={className}
                    error={error?.message}
                    touched={!!error}
                />
            )}
        />
    );
}